import { PlainDateType } from './dateTypes';
import { WorkflowState } from './workflow';
import { z } from 'zod';

export const BucketQuery = z.object({
    id: z.array(z.string()).nullish(),
    type: z.enum(['trip', 'standalone']).nullish(),
    ownerId: z.array(z.string()).nullish(),
    managerId: z.array(z.string()).nullish(),
    mine: z.boolean().nullish(),
    date: z.tuple([PlainDateType, PlainDateType]).nullish(),
    workflowState: z.array(WorkflowState).nullish(),
    archived: z.boolean().nullish(),
    search: z.string().nullish(),
    receiptType: z.array(z.string()).nullish(),
    recursive: z.boolean().nullish(),
    locationFrom: z.string().nullish(),
    locationTo: z.string().nullish(),
});
export type BucketQuery = z.infer<typeof BucketQuery>;

export const emptyBucketQuery = Object.fromEntries(
    BucketQuery.keyof().options.map((key) => [key, undefined]),
) as BucketQuery;
